// Copyright © 2021 Move Closer
import { computed } from '@vue/composition-api';
import { abstractBadgeProps } from '../../_abstract';
import { BootstrapBadgeTheme } from './Badge.contracts';
import { bootstrapBadgeThemeClassRegistry } from './Badge.config';
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
export const bootstrapBadgeProps = {
    ...abstractBadgeProps,
    /**
     * Badge's color (style) variant.
     */
    theme: {
        type: String,
        required: false,
        default: BootstrapBadgeTheme.Red
    }
};
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
export const useBootstrapBadge = (props) => {
    /**
     * CSS class defining the badge's color (style) variant.
     */
    const themeClass = computed(() => {
        if (typeof bootstrapBadgeThemeClassRegistry[props.theme] !== 'string') {
            console.warn(`useBootstrapBadge(): Provided registry does NOT contain the given key.\nFalling back to the first key in the set, which is [${Object.keys(bootstrapBadgeThemeClassRegistry)[0]}].`);
            return Object.values(bootstrapBadgeThemeClassRegistry)[0];
        }
        return bootstrapBadgeThemeClassRegistry[props.theme];
    });
    return { themeClass };
};
